


















import { Vue, Component, Prop } from 'vue-property-decorator';
import type { TabType } from "@/components/Globals/types/custom.t";
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import TabRandomize from "@/components/Globals/atom.tabRandomize.vue";
import Tab from "@/components/molecule.swatch.tab.vue";

@Component({
  components: {
    CustomContainer,
    Tab,
    TabRandomize
  },
})
export default class Tabs extends Vue {
  @Prop()
  tabs!: TabType[];

  get isMobile() {
    return this.$store.getters["utils/returnScreenSize"].includes('mobile');
  }

  get isRandomizeEnabled() {
    const { pdm, configuration } = this.$store.state.utils;
    return pdm &&
     !configuration.randomize?.turn_off_all_models &&
     configuration.randomize?.models_enabled.includes(pdm.sku);
  }
}
